(() => {
  const brandPattern = /the\s+br[\u0130I\u0131i]l[\u0130I\u0131i]an/giu;
  const navLabels = {
    '\u00fcr\u00fcnler': '\u00dcr\u00fcnler',
    urunler: '\u00dcr\u00fcnler',
    'skin journal': 'Skin Journal',
    'hakk\u0131m\u0131zda': 'Hakk\u0131m\u0131zda',
    hakkimizda: 'Hakk\u0131m\u0131zda',
    'ileti\u015fim': '\u0130leti\u015fim',
    iletisim: '\u0130leti\u015fim',
  };
  const skipTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA']);
  const attrs = ['aria-label', 'alt', 'title'];

  function normalize(value) {
    if (!value) return value;
    let nextValue = value.replace(brandPattern, 'The Brilian');
    const leading = nextValue.match(/^\s*/)?.[0] || '';
    const trailing = nextValue.match(/\s*$/)?.[0] || '';
    const core = nextValue.trim().replace(/\s+/g, ' ');
    const mapped = navLabels[core.toLocaleLowerCase('tr-TR')];
    return mapped ? `${leading}${mapped}${trailing}` : nextValue;
  }

  function normalizeTextNode(node) {
    const parent = node.parentElement;
    if (!parent || skipTags.has(parent.tagName)) return;
    const nextValue = normalize(node.nodeValue);
    if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
  }

  function normalizeAttributes(element) {
    if (!element || !element.getAttribute) return;
    attrs.forEach((attr) => {
      const value = element.getAttribute(attr);
      const nextValue = normalize(value);
      if (nextValue !== value) element.setAttribute(attr, nextValue);
    });
  }

  function normalizeRoot(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    normalizeAttributes(root);
    root.querySelectorAll?.('[aria-label], [alt], [title]').forEach(normalizeAttributes);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      normalizeTextNode(node);
      node = walker.nextNode();
    }
  }

  function injectStyles() {
    if (document.getElementById('brilian-final-polish-style')) return;
    const style = document.createElement('style');
    style.id = 'brilian-final-polish-style';
    style.textContent = `
:root{--buttons-radius:8px!important;--buttons-radius-outset:8px!important;--buttons-border-width:1px!important}
body,button,input,select,textarea,.header__inline-menu,.header__menu-item,.header__active-menu-item,.list-menu__item,.menu-drawer__menu-item,.card__heading,.card-information,.price,.product__info-container,.product-trust-item,.br-rhode-products,.br-rhode-story,.br-rhode-routine,.br-ritual,.br-funnel-engine,.br-product-conversion,.brillian-mega,.brillian-mega a,.brillian-fp-card,.bb-ugc{font-family:var(--font-body-family)!important;letter-spacing:0!important}
.header__menu-item,.header__active-menu-item,.list-menu__item,.menu-drawer__menu-item,.caption-with-letter-spacing,.brillian-mega__col-title,.brillian-mega__featured-title,.brillian-mega__promo-cta,.brillian-fp-card__badge,.brillian-fp-card__quick,.br-card-tester,.br-tester-gift__copy p,.br-story__heading p,.br-routine-card__step,.bb-ugc__plink,.bb-ugc__overlay-handle{text-transform:none!important;letter-spacing:0!important}
.header__heading-link,.header__heading-logo-wrapper{width:min(150px,36vw)!important;max-width:min(150px,36vw)!important;line-height:0!important;transition:none!important;transform:translateZ(0)!important}.section-header.scrolled-past-header .header__heading-logo-wrapper{width:min(150px,36vw)!important}.header__heading-logo{width:100%!important;max-width:100%!important;height:auto!important;transition:filter 160ms ease,opacity 160ms ease!important;transform:translateZ(0)!important}
.product__info-wrapper,.product__info-container{overflow:visible!important;max-height:none!important}product-info .unit-price,product-info .price-per-item__container,product-info price-per-item{display:none!important}.product-form__input{max-width:100%!important;min-width:0!important}
.product-form__input--locked .form__label{display:block;margin-bottom:8px;color:#20242b;font-family:var(--font-body-family)!important;font-size:1.25rem;font-weight:680;letter-spacing:0!important}.br-locked-option{display:flex;width:100%;min-height:52px;align-items:center;padding:0 16px;border:1px solid rgba(17,17,17,.24);border-radius:8px!important;background:#fff;color:#172036;font:inherit;font-size:1.35rem;font-weight:560;line-height:1.2;letter-spacing:0!important}.br-locked-option__select{position:absolute!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important}
.product-form__input--dropdown .select,.product-form__input--dropdown .select__select,.product-form__input .select,.product-form__input select,.select,.select__select,.quantity{border-radius:8px!important;box-shadow:none!important}.product-form__input--dropdown .select::before,.product-form__input--dropdown .select::after,.select::before,.select::after,.quantity::before,.quantity::after{content:none!important;display:none!important;box-shadow:none!important}
.button,.button--primary,.button--secondary,.product-form__submit,.shopify-payment-button__button,.shopify-payment-button__button--unbranded,.quick-add__submit,.cart__checkout-button,.br-rhode-button,.br-rhode-product__add,.br-rhode-story__link,.br-rhode-products__all,.br-funnel-card__link,.br-funnel-engine__cta,.br-routine-card__add,.br-right-set__form button,.br-story-dialog__done{border-radius:8px!important;font-family:var(--font-body-family)!important;letter-spacing:0!important;text-transform:none!important;box-shadow:none!important}
product-form .button,product-form button,product-info .button,product-info button,.product-form__buttons .button,.product-form__buttons button,button.product-form__submit.button,.shopify-payment-button .shopify-payment-button__button,.shopify-payment-button button{border-radius:8px!important;text-transform:none!important;letter-spacing:0!important;box-shadow:none!important}
.button::before,.button::after,.product-form__submit::before,.product-form__submit::after,.shopify-payment-button__button::before,.shopify-payment-button__button::after,.quick-add__submit::before,.quick-add__submit::after,.cart__checkout-button::before,.cart__checkout-button::after{content:none!important;display:none!important;box-shadow:none!important}
.br-product-answers,.br-conversion-map,.br-active-lock,.br-routine-card,.br-right-set__card,.br-story-dialog,.br-tester-gift,.br-cart-recommendation,.br-cart-recommendation__media,.br-rhode-hero,.br-rhode-story,.br-ritual,.br-trust-strip,.brillian-editorial-card,.bb-ugc__media,.bb-ugc__pmini,.bb-ugc__overlay-handle{border-radius:8px!important}
.br-story__rail,.br-story--right .br-story__rail{display:flex!important;gap:10px!important;overflow-x:auto!important;overflow-y:hidden!important;scroll-snap-type:x proximity!important;scrollbar-width:none!important}.br-story__rail::-webkit-scrollbar,.br-story--right .br-story__rail::-webkit-scrollbar{display:none!important}.br-story__item{flex:0 0 76px!important;scroll-snap-align:start!important}.br-story--right .br-story__item{flex:0 0 72px!important}.br-story__image{width:76px!important;height:76px!important;border-radius:50%!important}.br-story__image img,.br-story--right .br-story__image img{width:100%!important;height:100%!important;border-radius:50%!important;object-fit:cover!important;object-position:center!important}.br-story--right .br-story__image{width:68px!important;height:68px!important;border-radius:50%!important}.br-story--right .br-story__item>span:last-child{max-width:72px!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important}
.bb-ugc__video,.bb-ugc__img,.bb-ugc__poster,.br-rhode-hero__media video,.br-rhode-story__media video{filter:none!important}.product__media-wrapper .product__media,.product__media-wrapper .global-media-settings{border-radius:8px!important;overflow:hidden!important}.product__media img,.card__media img,.br-rhode-product__media img{opacity:1!important}
@media screen and (min-width:990px){.product__column-sticky{top:calc(var(--header-height,86px) + 18px)!important}.product--large:not(.product--no-media) .product__media-wrapper,.product--medium:not(.product--no-media) .product__media-wrapper,.product--small:not(.product--no-media) .product__media-wrapper{width:calc(50% - 17px)!important;max-width:calc(50% - 17px)!important}.product--large:not(.product--no-media) .product__info-wrapper,.product--medium:not(.product--no-media) .product__info-wrapper,.product--small:not(.product--no-media) .product__info-wrapper{width:calc(50% - 17px)!important;max-width:calc(50% - 17px)!important}}
@media screen and (max-width:749px){.header__heading-link,.header__heading-logo-wrapper,.section-header.scrolled-past-header .header__heading-logo-wrapper{width:min(132px,36vw)!important;max-width:min(132px,36vw)!important}.br-story--right .br-story__image{width:66px!important;height:66px!important}.br-story--right .br-story__item{flex-basis:70px!important}}
`;
    document.head.appendChild(style);
  }

  function lockSingleVariantSelects(root) {
    const scope = root?.querySelectorAll ? root : document;
    scope.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((block) => {
      const select = block.querySelector('select');
      if (!select || select.options.length !== 1 || block.querySelector('.br-locked-option')) return;
      const option = select.selectedOptions[0] || select.options[0];
      locked = document.createElement('div');
      locked.className = 'br-locked-option';
      locked.setAttribute('aria-label', `${block.querySelector('.form__label')?.textContent?.trim() || ''}: ${option.textContent.trim()}`);
      locked.innerHTML = `<span>${option.textContent.trim()}</span>`;
      select.classList.add('br-locked-option__select');
      select.hidden = true;
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;
      block.classList.add('product-form__input--locked');
      const selectWrap = select.closest('.select');
      if (selectWrap) selectWrap.hidden = true;
      block.querySelector('.form__label')?.insertAdjacentElement('afterend', locked);
    });
  }

  let mediaObserver;

  function wakeImage(img, priority) {
    if (!img) return;
    img.decoding = 'async';
    if (img.dataset.src && !img.getAttribute('src')) img.setAttribute('src', img.dataset.src);
    if (img.dataset.srcset && !img.getAttribute('srcset')) img.setAttribute('srcset', img.dataset.srcset);
    if (priority || img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    if ('fetchPriority' in img) img.fetchPriority = priority ? 'high' : 'auto';
    img.decode?.().catch(() => {});
  }

  function isNearViewport(img) {
    const rect = img.getBoundingClientRect();
    return rect.bottom > -240 && rect.top < window.innerHeight + 640 && rect.right > -220 && rect.left < window.innerWidth + 620;
  }

  function observeDeferredImage(img) {
    if (!img || img.dataset.brObserved === 'true') return;
    if (!mediaObserver && 'IntersectionObserver' in window) {
      mediaObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            wakeImage(entry.target, false);
            mediaObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '640px 520px', threshold: 0.01 }
      );
    }
    if (mediaObserver) {
      img.dataset.brObserved = 'true';
      mediaObserver.observe(img);
    }
  }

  function rememberProductImageSource(img) {
    if (!img) return;
    const src = img.getAttribute('src');
    const srcset = img.getAttribute('srcset');
    if (src && !img.dataset.brOriginalSrc) img.dataset.brOriginalSrc = src;
    if (srcset && !img.dataset.brOriginalSrcset) img.dataset.brOriginalSrcset = srcset;
    if (img.currentSrc && img.naturalWidth > 0 && !img.dataset.brOriginalCurrentSrc) {
      img.dataset.brOriginalCurrentSrc = img.currentSrc;
    }
  }

  function productImageFallbackUrl(img) {
    const sources = [];
    const push = (value) => {
      if (!value) return;
      const url = new URL(value, window.location.href);
      const clean = url.toString();
      if (!sources.includes(clean)) sources.push(clean);
    };
    const pushSrcset = (srcset) => {
      String(srcset || '')
        .split(',')
        .map((item) => item.trim().split(/\s+/)[0])
        .forEach(push);
    };
    push(img.dataset.brOriginalCurrentSrc);
    push(img.dataset.brOriginalSrc);
    pushSrcset(img.dataset.brOriginalSrcset);
    push(img.currentSrc);
    push(img.getAttribute('src'));
    pushSrcset(img.getAttribute('srcset'));
    document.querySelectorAll('.thumbnail img,.product__media img').forEach((candidate) => {
      if (candidate === img) return;
      if (candidate.alt && img.alt && candidate.alt !== img.alt) return;
      rememberProductImageSource(candidate);
      push(candidate.dataset.brOriginalCurrentSrc);
      push(candidate.dataset.brOriginalSrc);
      pushSrcset(candidate.dataset.brOriginalSrcset);
      push(candidate.currentSrc || candidate.getAttribute('src'));
    });
    const variants = [];
    const addVariant = (value) => {
      if (value && !variants.includes(value)) variants.push(value);
    };
    for (const source of sources) {
      const url = new URL(source, window.location.href);
      if (url.searchParams.has('width')) {
        for (const width of ['713', '600', '493', '360', '246']) {
          const variant = new URL(url);
          variant.searchParams.set('width', width);
          addVariant(variant.toString());
        }
      }
      addVariant(url.toString());
    }
    const attempt = Number(img.dataset.brRecoveries || 0);
    return variants[attempt] || variants[0] || '';
  }

  function recoverImage(img) {
    if (!img) return;
    const attempt = Number(img.dataset.brRecoveries || 0);
    if (attempt >= 5) return;
    const rect = img.getBoundingClientRect();
    const visible = rect.width > 20 && rect.height > 20 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
    if (!visible && !img.closest('.product__media')) return;
    const fallback = productImageFallbackUrl(img);
    if (!fallback) return;
    img.dataset.brRecovered = 'true';
    img.dataset.brRecoveries = String(attempt + 1);
    img.removeAttribute('srcset');
    img.setAttribute('sizes', `${Math.ceil(rect.width || 700)}px`);
    img.setAttribute('loading', 'eager');
    if ('fetchPriority' in img) img.fetchPriority = visible ? 'high' : 'auto';
    img.src = fallback;
  }

  function recoverBrokenProductImages(root) {
    const scope = root?.querySelectorAll ? root : document;
    const images = [...scope.querySelectorAll('.product__media img,.product__media-list img')];
    images.forEach((img) => {
      rememberProductImageSource(img);
      if (img.dataset.brRecoveryBound === 'true') return;
      img.dataset.brRecoveryBound = 'true';
      img.addEventListener('load', () => rememberProductImageSource(img), { passive: true });
      img.addEventListener('error', () => recoverImage(img), { passive: true });
    });
    const check = () => {
      images.forEach((img) => {
        if ((img.complete && img.naturalWidth === 0) || (!img.complete && isNearViewport(img))) recoverImage(img);
      });
    };
    window.setTimeout(check, 900);
    window.setTimeout(check, 2200);
    window.addEventListener('load', check, { once: true, passive: true });
  }

  function stabilizeMedia(root) {
    const scope = root?.querySelectorAll ? root : document;
    const productImages = [...scope.querySelectorAll('.product__media img')];
    productImages.forEach((img, index) => {
      if (index < 2 || isNearViewport(img)) {
        wakeImage(img, index === 0);
      } else {
        img.decoding = 'async';
        observeDeferredImage(img);
      }
    });
    scope.querySelectorAll('.card__media img,.br-rhode-product__media img,.bb-ugc__poster,.bb-ugc__img,.bb-ugc__pimg,.br-story__item img').forEach((img, index) => {
      if (index < 4 || isNearViewport(img)) {
        wakeImage(img, index < 2 && img.closest('.card__media,.br-rhode-product__media'));
      } else {
        img.decoding = 'async';
        observeDeferredImage(img);
      }
    });
  }

  function manageUgcVideos(root) {
    const scope = root?.querySelectorAll ? root : document;
    const sections = [];
    if (scope.matches?.('.bb-ugc')) sections.push(scope);
    scope.querySelectorAll('.bb-ugc').forEach((section) => sections.push(section));

    sections.forEach((section) => {
      if (section.dataset.brUgcGovernor === 'true') return;
      const track = section.querySelector('[data-ugc-track]');
      const videos = [...section.querySelectorAll('.lazy-video,.bb-ugc__video')];
      if (!track || !videos.length) return;

      section.dataset.brUgcGovernor = 'true';
      const mobileQuery = window.matchMedia('(max-width: 768px)');
      let syncTimer;

      const isMobile = () => mobileQuery.matches;
      const sectionVisible = () => {
        const rect = section.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      };
      const storedSrc = (video) => {
        if (!video.dataset.brSrc && video.dataset.src) video.dataset.brSrc = video.dataset.src;
        return video.dataset.brSrc || video.dataset.src || '';
      };
      const releaseVideo = (video) => {
        const src = storedSrc(video);
        video.pause();
        video.classList.remove('is-playing');
        if (isMobile() && src) video.dataset.src = '';
        if (video.src) {
          video.removeAttribute('src');
          video.load();
        }
      };
      const hydrateVideo = (video) => {
        const src = storedSrc(video);
        if (!src) return;
        video.dataset.src = src;
        if (!video.src) {
          video.src = src;
          video.load();
        }
      };
      const closestVideo = () => {
        if (!sectionVisible()) return null;
        const trackRect = track.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;
        let closest = null;
        let min = Infinity;
        videos.forEach((video) => {
          const rect = video.getBoundingClientRect();
          if (rect.right < 0 || rect.left > window.innerWidth || rect.bottom < 0 || rect.top > window.innerHeight) return;
          const distance = Math.abs(center - (rect.left + rect.width / 2));
          if (distance < min) {
            min = distance;
            closest = video;
          }
        });
        return closest;
      };
      const syncVideos = () => {
        if (!isMobile()) return;
        const active = closestVideo();
        videos.forEach((video) => {
          if (video === active) {
            hydrateVideo(video);
            video.play?.().catch(() => {});
            video.classList.add('is-playing');
          } else {
            releaseVideo(video);
          }
        });
      };
      const scheduleSync = () => {
        window.clearTimeout(syncTimer);
        syncTimer = window.setTimeout(syncVideos, 80);
      };

      videos.forEach((video) => {
        storedSrc(video);
        if (isMobile()) video.dataset.src = '';
        new MutationObserver(() => {
          if (!isMobile()) return;
          const active = closestVideo();
          if (video !== active) releaseVideo(video);
        }).observe(video, { attributes: true, attributeFilter: ['src'] });
      });

      track.addEventListener('scroll', scheduleSync, { passive: true });
      window.addEventListener('resize', scheduleSync, { passive: true });
      mobileQuery.addEventListener?.('change', scheduleSync);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => {
            if (entries[0]?.isIntersecting) syncVideos();
            else videos.forEach(releaseVideo);
          },
          { threshold: 0.12 }
        ).observe(section);
      }

      window.setTimeout(syncVideos, 120);
      window.setTimeout(syncVideos, 700);
    });
  }

  function applyUiPolish(root) {
    injectStyles();
    lockSingleVariantSelects(root);
    stabilizeMedia(root);
    recoverBrokenProductImages(root);
    manageUgcVideos(root);
  }

  function init() {
    if (!document.getElementById('brilian-brand-normalizer-style')) {
      const style = document.createElement('style');
      style.id = 'brilian-brand-normalizer-style';
      style.textContent = '.jdgm-full-rev__replier::before{content:\'The Brilian\' !important;}';
      document.head.appendChild(style);
    }
    normalizeRoot(document.body);
    applyUiPolish(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          normalizeTextNode(mutation.target);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          normalizeRoot(node);
          applyUiPolish(node);
        });
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
